module.exports = __webpack_public_path__ + "img/zyrtec_24hr_allergy_relief_liquid_gels.b1f1579f.png";